import styled from 'styled-components';

// Comme on utilise le formulaire existant, on va surcharger les
// marges qui ne servent qu'à l'affichage au sein du popover.
// → Devra être déplacé lors du nettoyage de la feature.
export const Container = styled.div`
  & > div {
    margin: 0;
  }
`;
